export const DOCUMENTS_SET_LIST_DATA = 'DOCUMENTS_SET_LIST_DATA';
export const DOCUMENTS_SET_LIST_META = 'DOCUMENTS_SET_LIST_META';
export const DOCUMENTS_TITLE="Tài liệu";